import React, { createContext, useState } from "react";
import { Estados } from "../../../../../repositories/qerpapi/erp/prouser/static/Estados";
import { Municipios } from "../../../../../repositories/qerpapi/erp/prouser/static/Municipios";
import { Paises } from "../../../../../repositories/qerpapi/erp/prouser/static/Paises";

const CompanyRuralEstablishmentsContext = createContext();

const CompanyRuralEstablishmentsContextProvider = ({ children }) => {
  const [mainLoading, setMainLoading] = useState(false);
  const [ruralEstablishment, setRuralEstablishment] = useState([]);
  const [rowsTotal, setRowsTotal] = useState(0);
  const [textFilter, setTextFilter] = useState("");
  const [listUf] = useState([...Estados]);
  const [listCounty] = useState([...Municipios]);
  const [listNation] = useState([...Paises]);

  return (
    <CompanyRuralEstablishmentsContext.Provider
      value={{
        mainLoading,
        setMainLoading,
        ruralEstablishment,
        setRuralEstablishment,
        rowsTotal,
        setRowsTotal,
        textFilter,
        setTextFilter,
        listUf,
        listCounty,
        listNation,
      }}
    >
      {children}
    </CompanyRuralEstablishmentsContext.Provider>
  );
};

export {
  CompanyRuralEstablishmentsContextProvider,
  CompanyRuralEstablishmentsContext,
};
